import React from 'react'
import { Avatar, Status, Icon, HorizontalStack, ShowIf } from '@ztechapps/webui.util'
import { PhoneNumberDisplay } from '../PhoneNumber/PhoneNumberDisplay'

type UserWidgetProps = {
  profile: { name: string; picture: string; email: string }
  status: string
  phone?: string
}
/**
 * This is  the default display for user,
 * @constructor
 */
export const UserWidget = ({ profile, status, phone }: UserWidgetProps) => {
  const { name, picture, email } = profile ?? {}

  return (
    <HorizontalStack className="justify-content-start align-items-center">
      <div className="me-1">
        <Avatar name={name} src={picture} />
      </div>
      <div>
        <div>
          <Status value={status} /> <span className="fw-bold">{name}</span>
        </div>
        <div className="small">
          <Icon name="envelope" /> {email}
        </div>
        <ShowIf condition={!!phone}>
          <div className="small">
            <Icon name="phone" /> <PhoneNumberDisplay value={phone} />
          </div>
        </ShowIf>
      </div>
    </HorizontalStack>
  )
}
